// AnalysisDetail.js — BL-048 (ADR-068) stable analysis-detail route
// (/my-analyses/:analysisId).
//
// Owner-scoped read via getAnalysisById (RLS returns only the caller's row, so
// a foreign/missing/malformed id resolves to a SAFE not-found — never a
// cross-user disclosure). Works after a fresh login + direct navigation, and
// serves EVERY authoritative successful analysis (BUY and non-BUY).

import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getAnalysisById } from "../lib/analyses";

export default function AnalysisDetail() {
  const { analysisId } = useParams();
  const [state, setState] = useState({ loading: true, row: null, notFound: false });

  useEffect(() => {
    let active = true;
    (async () => {
      const { data, error } = await getAnalysisById(analysisId);
      if (!active) return;
      if (error || !data) {
        setState({ loading: false, row: null, notFound: true });
      } else {
        setState({ loading: false, row: data, notFound: false });
      }
    })();
    return () => { active = false; };
  }, [analysisId]);

  if (state.loading) {
    return <div data-testid="analysis-detail-loading">Loading analysis…</div>;
  }

  if (state.notFound) {
    return (
      <section data-testid="analysis-detail-notfound" className="card" style={{ display: "grid", gap: "var(--space-2)" }}>
        <h2 style={{ margin: 0 }}>Analysis not found</h2>
        <p style={{ margin: 0 }}>This analysis doesn't exist or isn't available to your account.</p>
        <Link to="/my-analyses">Back to My Analyses</Link>
      </section>
    );
  }

  const row = state.row;
  const rec = row.recommendation || row.result?.recommendation?.decision || "—";

  return (
    <section data-testid="analysis-detail" className="card" style={{ display: "grid", gap: "var(--space-3)" }}>
      <header>
        <h2 style={{ margin: 0 }} data-testid="analysis-detail-address">
          {row.formatted_address || "Saved analysis"}
        </h2>
      </header>
      <dl style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: "var(--space-2)", margin: 0 }}>
        <dt style={{ color: "var(--color-text-muted)" }}>Recommendation</dt>
        <dd style={{ margin: 0 }} data-testid="analysis-detail-recommendation">{rec}</dd>
        <dt style={{ color: "var(--color-text-muted)" }}>DSCR</dt>
        <dd style={{ margin: 0 }}>{row.dscr ?? "—"}</dd>
        <dt style={{ color: "var(--color-text-muted)" }}>Deal score</dt>
        <dd style={{ margin: 0 }}>{row.deal_score ?? "—"}</dd>
      </dl>
      <Link to="/my-analyses">Back to My Analyses</Link>
    </section>
  );
}
